'use client'

import { useEffect } from 'react'
import { reportClientLog } from '@/lib/client-logger'

/**
 * Root-level error boundary. Unlike route `error.tsx`, this catches crashes in
 * the root layout itself, and it must render its own <html>/<body>. Reports the
 * error to the durable sink before showing a minimal fallback.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    reportClientLog({
      source: 'global-error',
      message: error.message || 'Root layout crashed',
      errorName: error.name,
      stack: error.stack,
      extra: error.digest ? { digest: error.digest } : undefined,
    })
  }, [error])

  return (
    <html lang="de">
      <body className="font-sans bg-paper text-ink min-h-screen">
        <div className="flex flex-col items-center justify-center min-h-screen p-8 font-mono text-center">
          <p className="text-xs uppercase tracking-widest opacity-50 mb-2">Fehler</p>
          <h2 className="text-xl font-bold uppercase mb-4">Etwas ist schiefgelaufen</h2>
          <p className="text-sm opacity-70 mb-6 max-w-sm">
            Die Anwendung konnte nicht geladen werden. Bitte lade die Seite neu.
          </p>
          <button
            onClick={reset}
            className="border border-ink px-4 py-2 text-xs uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors"
          >
            Erneut versuchen
          </button>
        </div>
      </body>
    </html>
  )
}
